import CaptainConversationScripts from 'dashboard/api/captain/conversationScripts';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'CaptainConversationScript',
  API: CaptainConversationScripts,
  getters: {
    getRecords: state =>
      [...state.records].sort((a, b) => a.position - b.position),
  },
  actions: mutations => ({
    update: async ({ commit }, { id, assistantId, ...updateObj }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainConversationScripts.update(
          { id, assistantId },
          updateObj
        );
        commit(mutations.EDIT, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },

    delete: async ({ commit }, { id, assistantId }) => {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await CaptainConversationScripts.delete({ id, assistantId });
        commit(mutations.DELETE, id);
        return id;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
      }
    },

    reorder: async ({ commit }, { assistantId, scriptIds }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainConversationScripts.reorder({
          assistantId,
          scriptIds,
        });
        commit(mutations.SET, response.data.payload);
        return response.data.payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
  }),
});
